exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".body-bgx[data-v-bbdbdc2e]{height:100%;width:100%}img[data-v-bbdbdc2e]{-webkit-filter:opacity(60%);filter:opacity(60%)}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/NotFoundView.vue"],"names":[],"mappings":"AACA,2BAEE,YAAY,AACZ,UAAW,CACZ,AACD,qBACI,4BAA6B,AAC/B,mBAAqB,CACtB","file":"NotFoundView.vue","sourcesContent":["\n.body-bgx[data-v-bbdbdc2e]{\n  /*position:absolute;*/\n  height:100%;\n  width:100%;\n}\nimg[data-v-bbdbdc2e] {\n    -webkit-filter: opacity(60%); /* Safari 6.0 - 9.0 */\n  filter: opacity(60%);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbdbdc2e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/NotFoundView.vue
// module id = 1421
// module chunks = 40